import BuyflowRoot from '~/Buyflow'
import InternetPage from '~/Buyflow/pages/Internet'
import TVPage from '~/Buyflow/pages/TV'
import TVChannelCounter from '~/Buyflow/components/TVChannelCounter'
import VoicePage from '~/Buyflow/pages/Voice'
import CheckoutPage from '~/Buyflow/pages/Checkout'
import SummaryPage from '~/Buyflow/pages/Summary'
import mainStore from '^/mainStore'
import mainMixins from '^/mainMixins'

// detect if the user agent is safari and not chrome
let safariAgent = (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1);

const smoothScrollToTop = (to, from, next) => {
    let proceed = true

    if (to.name === 'buyflow-summary') {
        const validated = {
            uuid: mainMixins.isValidUUID(to.query.uuid) ? to.query.uuid : null,
            conversationId: mainMixins.isValidCID(to.query.cid) ? to.query.cid : null,
        }
        if (validated.uuid || validated.conversationId) {
            mainStore.dispatch('setMeta', {
                uuid: validated.uuid,
                conversationId: validated.conversationId,
            })
        } else {
            proceed = false
            window.location.href = '/'
        }
    } else if (mainStore.state.meta.isCurrentCustomer && !mainStore.getters.isPendingDisconnect) {
        proceed = false
        window.location.href = '/'
    }

    if (proceed) {
        window.scroll({
            top: 0,
            left: 0,
            behavior: safariAgent? 'auto': 'smooth',
        })
        next()
    }

    if (proceed && to.name === 'buyflow-installation') {
        setTimeout(() => {
            window.scroll({
                top: 0,
                left: 0,
                behavior: safariAgent? 'auto': 'smooth',
            })
        }, 1500)
    }
}

const getRedirect = () => {
    if (!mainStore.getters['Buyflow/buyflowFeature']('buyflow_hide', 'internet')){
        return '/checkout/internet'
    } else if (!mainStore.getters['Buyflow/buyflowFeature']('buyflow_hide', 'tv')) {
        return '/checkout/tv'
    } else if (!mainStore.getters['Buyflow/buyflowFeature']('buyflow_hide', 'voice')) {
        return '/checkout/voice'
    }
    return '/checkout/finalize'
}

export default {
    name: 'buyflow',
    path: '/checkout',
    redirect: getRedirect(),
    components: {
        app: BuyflowRoot,
    },
    children: [
        {
            name: 'buyflow-abandoned-cart-redirect',
            path: 'retrieve-user-session',
            redirect: '/checkout/internet',
        },
        {
            name: 'buyflow-internet',
            path: 'internet',
            components: {
                main: InternetPage,
            },
            meta: {
                heading: `Let's start with your internet plan`,
                breadcrumbs: {
                    text: `Choose Internet &\n WiFi Options`,
                    shortText: `Internet`,
                },
                pageNav: {
                    nextText: `Next: Customize TV`,
                    nextShortText: `Customize TV`,
                    nextRouteName: `buyflow-tv`,
                    skipText: `Skip to Checkout`,
                    skipShortText: `Checkout`,
                    skipRouteName: `buyflow-installation`,
                    nextTypes: [`tv`,`voice`],
                    nextHiddenText: [`Next: Customize Voice`,`Next: Checkout`],
                    nextHiddenRouteName: [`buyflow-voice`, `buyflow-installation`],
                },
            },
            beforeEnter: smoothScrollToTop,
        },
        {
            name: 'buyflow-tv',
            path: 'tv',
            components: {
                main: TVPage,
                sidebarExtension: TVChannelCounter,
            },
            meta: {
                heading: `Would you like to add TV service?`,
                breadcrumbs: {
                    text: `Customize TV`,
                    shortText: `TV`,
                },
                pageNav: {
                    nextText: `Next: Customize Home Phone`,
                    nextRouteName: `buyflow-voice`,
                    skipText: `Skip to Checkout`,
                    skipShortText: `Checkout`,
                    skipRouteName: `buyflow-installation`,
                    nextTypes: [`voice`],
                    nextHiddenText: [`Next: Checkout`],
                    nextHiddenRouteName: [`buyflow-installation`],
                },
            },
            beforeEnter: (to, from, next) => {
                smoothScrollToTop(to, from, next)
                mainStore.dispatch('Buyflow/tv/fetchChannelLineup')
            },
        },
        {
            name: 'buyflow-voice',
            path: 'home-phone',
            components: {
                main: VoicePage,
            },
            meta: {
                heading: `Would you like to add home phone service?`,
                breadcrumbs: {
                    text: 'Customize Home Phone',
                    shortText: `Home Phone`,
                },
                pageNav: {
                    nextText: 'Next: Finalize & Checkout',
                    nextShortText: `Next: Finalize`,
                    nextRouteName: 'buyflow-installation',
                    skipText: `Skip to Checkout`,
                    skipShortText: `Checkout`,
                    skipRouteName: `buyflow-installation`,
                },
            },
            beforeEnter: smoothScrollToTop,
        },
        {
            name: 'buyflow-installation',
            path: 'finalize',
            components: {
                main: CheckoutPage,
            },
            meta: {
                heading: `Checkout`,
                breadcrumbs: {
                    text: 'Checkout',
                    shortText: 'Checkout',
                },
                pageNav: {
                    nextText: 'Complete My Order',
                    nextRouteName: 'buyflow-summary',
                },
            },
            beforeEnter: smoothScrollToTop,
        },
        {
            name: 'buyflow-summary',
            path: 'summary',
            components: {
                main: SummaryPage
            },
            beforeEnter: (to, from, next) => {
                smoothScrollToTop(to, from, next)
                mainStore.dispatch('Buyflow/summary/completeOrder')
                mainStore.dispatch('Buyflow/summary/orderSummary').then(() => {
                    if (from.name !== null) {
                        mainStore.dispatch('Buyflow/tracking/trackCompletedOrder')
                    }
                })
            },
        },
    ],
}
